export default __webpack_public_path__ + "static/media/image2.a0e1fa68.jpg";